import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';

export const VoiceFailureTable = ({ failures }) => (
  <section className="space-y-4" data-testid="voice-failure-table-section">
    <div>
      <p className="text-xs font-semibold uppercase text-[#8B7355]">Recent failures</p>
      <h2 className="mt-1 font-serif text-2xl text-[#1A1A1A]">Anonymous diagnostic trail</h2>
      <p className="mt-1 text-sm text-[#5C5C5C]">User identity and raw transcripts are excluded.</p>
    </div>
    <div className="border-y border-[#EAE5D9] bg-white">
      <Table data-testid="voice-failure-table">
        <TableHeader>
          <TableRow>
            {['Session', 'Time', 'Stage', 'Browser / OS', 'Codec', 'Diagnostic'].map((heading) => (
              <TableHead className="px-4 text-xs uppercase text-[#8A8A8A]" key={heading}>{heading}</TableHead>
            ))}
          </TableRow>
        </TableHeader>
        <TableBody>
          {failures.map((failure, index) => (
            <TableRow key={`${failure.session_id}-${failure.stage}`} data-testid={`voice-failure-row-${index}`}>
              <TableCell className="px-4 font-mono text-xs text-[#1E3F33]">{failure.session_id}</TableCell>
              <TableCell className="px-4 text-xs text-[#5C5C5C]">{new Date(failure.timestamp).toLocaleString()}</TableCell>
              <TableCell className="px-4"><span className="bg-[#FDECE8] px-2 py-1 text-xs font-semibold text-[#C85A3C]">{failure.stage}</span></TableCell>
              <TableCell className="px-4 text-sm text-[#5C5C5C]">{failure.browser} · {failure.os}<br /><span className="text-xs text-[#8A8A8A]">{failure.device}</span></TableCell>
              <TableCell className="px-4 text-xs text-[#5C5C5C]">{failure.codec}</TableCell>
              <TableCell className="max-w-sm px-4 text-sm text-[#1A1A1A]">{failure.diagnostic}</TableCell>
            </TableRow>
          ))}
          {!failures.length && (
            <TableRow>
              <TableCell colSpan={6} className="h-28 text-center text-sm text-[#8A8A8A]" data-testid="voice-failure-empty-state">
                No failed sessions recorded in this range.
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </div>
  </section>
);
